export default {"src":"/_next/static/media/icon_nav_dd_projects_tools_off.fd5c8be8.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};